import { useTranslation } from 'react-i18next';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { useQuery } from '@tanstack/react-query';
import { getDeployedTenantGroupOverrides, ListNamesDictionary } from 'Services';
import { RQ_GET_DEPLOYED_TENANT_GROUP_OVERRIDES } from 'Utils';
import { transformServerData } from '../helper';

type Props = {
    tenantGroupId: string;
    version?: number;
    users?: UsersHashmap;
    enabled?: boolean;
    listNameMap?: ListNamesDictionary;
    parameterData?: UseGetParametersResponse;
};

const useGetDeployedTenantGroupOverrides = ({
    tenantGroupId,
    version,
    users,
    enabled,
    listNameMap,
    parameterData
}: Props) => {
    const { t } = useTranslation();
    const { templateRepositoryId } = useTemplateStore.getState().template;
    return useQuery(
        [RQ_GET_DEPLOYED_TENANT_GROUP_OVERRIDES, templateRepositoryId],
        () => getDeployedTenantGroupOverrides(templateRepositoryId!, tenantGroupId, version),
        {
            enabled: !!(templateRepositoryId && templateRepositoryId > 0) && enabled !== false,
            select: transformServerData({ t, users, listNameMap, parameterData })
        }
    );
};

export default useGetDeployedTenantGroupOverrides;
